




































































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import PaymentProvidersInjectorMixin from "@/mixins/paymentProvidersInjectorMixin";

// Enums/Data
import { GatewayTypes } from "@/data/enums";

@Component({
  components: {
    "items-grid": () =>
      import("@/components/app/admin/settings/paymentProviders/itemsGrid.vue")
  }
})
export default class PaymentProvidersListItem extends Mixins(
  PaymentProvidersInjectorMixin
) {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public paymentProvider!: any;

  @Prop({ default: false })
  public isUnassigned!: boolean;

  @Prop({ default: false })
  public isSortableDisabled!: boolean;

  // Data

  public isActive = this.isUnassigned;
  public isVisible = this.isUnassigned;
  public isProcessing = false;

  // Life-cycle methods

  public created() {
    if (!this.isUnassigned) {
      this.$set(this, "isActive", this.paymentProvider?.active ?? false);
      this.$set(this, "isVisible", this.paymentProvider?.visible ?? false);
    }
  }

  // Methods

  public async assignPaymentProvider() {
    try {
      this.isProcessing = true;

      await this.$paymentProvidersMethods.assignPaymentProvider(
        this.paymentProvider.id
      );

      await this.$paymentProvidersMethods.refreshData();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.payment_provider_successfully_assigned")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.paymentProvider);
  }

  public get gatewayImageUrl() {
    return _.get(
      _.find(
        this.paymentProvider.gateway_provider.logos,
        logo => logo.type === "icon" && logo.size === "1x"
      ),
      "url",
      ""
    );
  }

  public get paymentProviderCurrencies() {
    return this.paymentProvider.currencies || [];
  }

  public get paymentProviderCountries() {
    return this.paymentProvider.countries || [];
  }

  public get showGatewayIcon() {
    return [GatewayTypes.BANK_TRANSFER, GatewayTypes.OFFLINE].includes(
      this.paymentProvider.type
    );
  }

  public get gatewayIcon() {
    if (this.paymentProvider.type === GatewayTypes.BANK_TRANSFER)
      return "university";
    if (this.paymentProvider.type === GatewayTypes.OFFLINE) return "coins";

    return "";
  }

  public get isClickable() {
    return (
      !!this.paymentProvider &&
      this.paymentProvidersData.canEdit &&
      !this.isUnassigned
    );
  }
}
